module.exports = __webpack_public_path__ + "img/demo_input.7f3a70cd.png";